import Vue from "vue";
import Router from "vue-router";
// import operate from "./operate.js";
// import baidu from "./baidu.js";
import website from "./website.js"
import websiteH5 from "./websiteh5.js"

Vue.use(Router);

const originPush = Router.prototype.push;

Router.prototype.push = function push(location){
  return originPush.call(this,location).catch(err=>console.warn(err))
}

let routes = [
  
];

const title = "";

routes.forEach((item, index) => {
  if (!item.meta) {
    item.meta = { title };
  } else {
    if (!item.meta.title) {
      item.meta.title = title;
    }
  }
});
// operate,baidu,
routes = routes.concat(website,websiteH5);

export default new Router({
  routes,
  base: '/',
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if(!to || !to.name) return {};
    
    if(to.name == 'websiteRecruit' && to.query && to.query.sol == 'effect'){
      return {x:0,y:700}
    }else if(to.name.indexOf('H5') != -1){
      return {x: 0, y: 0 }
    }else{
      return {};
    }
    
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js